import { NumberFormat } from "components/Common/NumberFormat/NumberFormat";
import { IGetMyServiceListRes } from "src/service/types/console.type";
import DatePicker from "react-datepicker";
import moment from "moment";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { dateFormatUtc } from "src/utils/dateManagement";
import ReactInicis from "components/Common/Inicis/ReactInicis";
import ReactInicisCardNew from "components/Common/Inicis/ReactInicisCardNew";
import useBillStatement from "src/hooks/Modal/Bill/useBillStatement";
import { useRecoilState } from "recoil";
import { serviceNoAtom } from "src/atoms";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useRouter } from "src/hooks/useRouter";
import { useEffect, useState } from "react";
// 요금제 정보
interface IPayInfoSectionProps {
  serviceList: IGetMyServiceListRes[];
  userCashStatus: any;
  nowDate: number;
  nowTime: number;
  isChangePrice: boolean; // 가격변경 가능 여부
  ableEditBtn: boolean; // 변경 버튼 표기 여부
  inicisData: any; // ReactInicis에 세팅됨
  currency: string; // ReactInicis에 세팅됨
  requestPay: (e: React.MouseEvent<HTMLButtonElement>) => void;
  toggleModalSubscriptionsActivate: () => void;
  renewSubscriptions: () => void;
  dateDifference: number;
  serviceUid: string;
  newDepositName: any;
  showTaxInvoiceFields: any;
  showCashReqModal: any;
  handleChangeTaxInvoice: any;
}
const PayInfoSection = ({
  userCashStatus,
  serviceList,
  nowDate,
  nowTime,
  isChangePrice,
  ableEditBtn,
  inicisData,
  currency,
  requestPay,
  toggleModalSubscriptionsActivate,
  renewSubscriptions,
  dateDifference,
  serviceUid,
  newDepositName,
  showTaxInvoiceFields,
  showCashReqModal,
}: IPayInfoSectionProps) => {
  const [serviceNo] = useRecoilState(serviceNoAtom);
  const { lang } = useRouter();
  const { togglePayInfoModal } = useBillStatement();
  const [subscriptionEndDate, setSubscriptionEndDate] = useState(
    dayjs(serviceList[0]?.subscriptionEndDate)
      .add(1, "day")
      .format("YYYY-MM-DD"),
  );
  useEffect(() => {
    if (subscriptionEndDate !== undefined) {
      setSubscriptionEndDate(
        dayjs(serviceList[0]?.subscriptionEndDate)
          .add(1, "day")
          .format("YYYY-MM-DD"),
      );
    }
  }, [serviceList]);
  const setGoodName = () => {
    const product = getProductFromSessionStorage();
    const productNameMap: Record<string, string> = {
      WRAPSODY_ECO: "Wrapsody eCo Cloud",
      WRAPSODY: "Wrapsody Cloud",
    };

    return productNameMap[product] || "";
  };
  const { t } = useTranslation();
  const changePriceName = (priceType: string) => {
    const product = getProductFromSessionStorage();

    const priceNameMap: Record<string, string> = {
      drive: "Basic",
      basic: "Standard",
      basicPlus: "Standard Plus",
      plus: "Enterprise",
      plusPlus: "Enterprise Plus",
    };

    return product === "WRAPSODY" ? priceNameMap[priceType] : priceType;
  };

  return (
    <div className="billMgnt">
      <div className="flex justify-space-between align-center">
        <div>
          <b className="text text--lg text--black">
            {t("siteManagement.paymentHistory.paymentManagement.title")}
          </b>
          {/* {!serviceList[serviceNo].priceName &&
    serviceList[serviceNo].billType !== "PROMOTION" &&
    serviceList[serviceNo].payCompany !== "CASH" ? (
      <b
        className="text text--green cursor-pointer mg ml-10"
        onClick={changeServiceType}
        style={{ display: ableEditBtn ? "inline" : "none" }}
        aria-disabled={!isChangePrice}
      >
        {t("common.edit")}
      </b>
    ) : (
      ""
    )} */}
          <b className="mg ml-10">
            <a className="text text--green" href={`mailto:cloud@fasoo.com`}>
              {t("siteManagement.paymentHistory.bill.inquiry")}
            </a>
          </b>
          {serviceList[serviceNo]?.billType === "PROMOTION" &&
          Number(serviceList[serviceNo]?.serviceEndTime) >= nowTime &&
          serviceList[serviceNo]?.payCompany !== "CASH" ? (
            <b
              className="text text--green cursor-pointer mg ml-10"
              style={{ display: ableEditBtn ? "inline" : "none" }}
              onClick={renewSubscriptions}
            >
              {t("common.edit")}
            </b>
          ) : (
            ""
          )}
        </div>

        {serviceList[serviceNo]?.billType === "PAY" &&
        serviceList[serviceNo]?.payStatus === "PAYED" ? ( // 일반적인 결제 상태
          // serviceList[serviceNo]?.billType === "PAY" ?
          <div>
            {(serviceList[serviceNo]?.payCompany === "INICIS" ||
              serviceList[serviceNo]?.payCompany === "CASH") &&
              // &&
              // unregisterBillList?.length > 0
              lang === "ko" && (
                <ReactInicis
                  isCardChange={true}
                  payData={inicisData}
                  currency={currency}
                  goodName={setGoodName()}
                >
                  <button
                    type="button"
                    className="btn btn-transparent text text--green"
                    // onClick={(
                    //   e: React.MouseEvent<HTMLButtonElement, MouseEvent>
                    // ) => {
                    //   e.preventDefault();
                    // }}
                    onMouseDown={(e: any) => {
                      // alert("click");
                      requestPay(e);
                    }}
                    // onClick={requestPay}
                  >
                    <i className="icon_minus_green inline-block vertical-middle" />
                    <span className="inline-block vertical-middle mg ml-2">
                      {
                        serviceList[serviceNo]?.payCompany === "INICIS"
                          ? t("common.changeCard") // 결제 카드 교체
                          : t("cashStatus.changeToCard") // 카드로 교체
                      }
                    </span>
                  </button>
                </ReactInicis>
              )}
            {/* 정기결제 해지 */}
            {/* {unregisterBillList?.length > 0 && ( */}
            <button
              type="button"
              className="btn btn-transparent text text--orange"
              // onClick={toggleModalSubscriptionsCancel}
              onClick={() => togglePayInfoModal({ info: "subscriptionCancel" })}
            >
              <i className="icon_trash inline-block vertical-middle" />
              <span className="inline-block vertical-middle mg ml-2">
                {t(
                  "siteManagement.paymentHistory.paymentManagement.cancelSubscription",
                )}
              </span>
            </button>
            {/* )} */}
          </div>
        ) : serviceList[serviceNo]?.billType === "PAY" &&
          serviceList[serviceNo]?.payStatus === "ENDING" ? (
          <></>
        ) : (
          ""
        )}
        {serviceList[serviceNo]?.billType === "PAY" &&
        serviceList[serviceNo]?.payStatus === "SUSPENDED" ? (
          <b
            className="text text--green cursor-pointer mg ml-10"
            onClick={toggleModalSubscriptionsActivate}
          >
            {/* 프로모션이 아니고 구독 기간 만료되었을 때 재구독(해지 취소하기) 버튼 생성 */}
            {t(
              "siteManagement.paymentHistory.paymentManagement.resubscription",
            )}
          </b>
        ) : serviceList[serviceNo]?.billType === "PAY" &&
          serviceList[serviceNo]?.payStatus === "ENDING" ? (
          <div>
            {/* 카드 교체 후 구독 재개하기 */}
            <ReactInicisCardNew currency={currency} goodName={setGoodName()} />

            {/* <b
              className="text text--green cursor-pointer mg ml-10"
              onClick={() => setResumeSubscription(true)}
            > */}
            {/* 구독 재개하기 */}
            {/* {t(
                "siteManagement.paymentHistory.paymentManagement.resumeSubscription"
              )}
            </b> */}
          </div>
        ) : (
          ""
        )}
        {serviceList[serviceNo]?.billType === "PROMOTION" &&
        Number(serviceList[serviceNo]?.serviceEndTime) < nowTime ? (
          <b
            className="text text--green cursor-pointer mg ml-10"
            onClick={renewSubscriptions}
          >
            {t(
              "siteManagement.paymentHistory.paymentManagement.resubscription",
            )}
          </b>
        ) : (
          ""
        )}
      </div>
      <hr className="mg mt-10" />

      {/* 요금제 */}
      <div className="billMgnt__item">
        <div className="billMgnt__itemKey">
          {t("siteManagement.paymentHistory.paymentManagement.payment")}
        </div>
        <div className="billMgnt__itemValue">
          {serviceList[serviceNo]?.billType === "TRIAL"
            ? t("subscriptionType.type.free_2")
            : ""}
          {serviceList[serviceNo]?.billType === "PROMOTION"
            ? t("subscriptionType.type.premium")
            : ""}
          {serviceList[serviceNo]?.billType === "PAY"
            ? changePriceName(serviceList[serviceNo].priceType)
            : ""}

          {/* {serviceList[serviceNo]?.billType === 'PAY' &&
    serviceList[serviceNo]?.priceType === 'plus'
      ? t('subscriptionType.type.plus')
      : ''}
    {serviceList[serviceNo]?.billType === 'PAY' &&
    serviceList[serviceNo]?.priceType === 'basic'
      ? t('subscriptionType.type.basic')
      : ''} */}
          {serviceList[serviceNo]?.billType === "PAY" &&
          serviceList[serviceNo]?.nextPayDate >= nowDate &&
          serviceList[serviceNo]?.payStatus !== "SUSPENDED" &&
          // isChangePrice &&
          serviceList[serviceNo]?.payCompany !== "CASH" ? (
            <b
              className="text text--green cursor-pointer mg ml-10"
              style={{ display: ableEditBtn ? "inline" : "none" }}
              onClick={() => togglePayInfoModal({ info: "priceType" })}
            >
              {t("common.edit")}
            </b>
          ) : (
            ""
          )}
        </div>
      </div>
      {/* 사용자 */}
      <div className="billMgnt__item">
        <div className="billMgnt__itemKey">
          {t("siteManagement.paymentHistory.paymentManagement.user")}
        </div>
        <div className="billMgnt__itemValue">
          {serviceList[serviceNo]?.licenseCount}

          {serviceList[serviceNo]?.priceType &&
          serviceList[serviceNo]?.nextPayDate >= nowDate &&
          serviceList[serviceNo]?.payStatus !== "SUSPENDED" &&
          isChangePrice &&
          serviceList[serviceNo]?.payCompany !== "CASH" ? (
            <b
              className="text text--green cursor-pointer mg ml-10"
              style={{ display: ableEditBtn ? "inline" : "none" }}
              onClick={() => togglePayInfoModal({ info: "licenseCount" })}
            >
              {t("common.edit")}
            </b>
          ) : (
            ""
          )}
        </div>
      </div>
      {/* 결제 주기 */}
      {serviceList[serviceNo]?.priceType ? (
        <div className="billMgnt__item">
          <div className="billMgnt__itemKey">
            {t("siteManagement.paymentHistory.paymentManagement.paymentCycle")}
          </div>
          <div className="billMgnt__itemValue">
            {serviceList[serviceNo]?.payTerm === "month"
              ? t(
                  "siteManagement.paymentHistory.popUp.changePaymentCycle.payType_month",
                )
              : t(
                  "siteManagement.paymentHistory.popUp.changePaymentCycle.payType_annual",
                )}
            {serviceList[serviceNo]?.priceType &&
            serviceList[serviceNo]?.nextPayDate >= nowDate &&
            serviceList[serviceNo]?.payStatus !== "SUSPENDED" &&
            isChangePrice &&
            serviceList[serviceNo]?.payCompany !== "CASH" ? (
              <b
                className="text text--green cursor-pointer mg ml-10"
                style={{ display: ableEditBtn ? "inline" : "none" }}
                onClick={() => togglePayInfoModal({ info: "payTerm" })}
              >
                {t("common.edit")}
              </b>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        ""
      )}
      {/* 최대 용량 */}
      {!["DSP", "MIND_SAT"].includes(serviceList[serviceNo]?.product) && (
        <div className="billMgnt__item">
          <div className="billMgnt__itemKey">
            {t("siteManagement.paymentHistory.paymentManagement.maxStorage")}
          </div>
          <div className="billMgnt__itemValue">
            {serviceList[serviceNo]?.licenseCount *
              serviceList[serviceNo]?.userPerStorage}
          </div>
        </div>
      )}
      {/* 사이트 개설일 */}
      <div className="billMgnt__item">
        <div className="billMgnt__itemKey">
          {t("siteManagement.paymentHistory.paymentManagement.startDate")}
        </div>
        <div className="billMgnt__itemValue">
          {serviceList[serviceNo]?.serviceEntryTime === "0"
            ? "-"
            : dateFormatUtc(serviceList[serviceNo]?.serviceEntryTime)}
        </div>
      </div>
      {/* 사이트 만료일 */}
      <div className="billMgnt__item">
        <div className="billMgnt__itemKey">
          {t("siteManagement.paymentHistory.paymentManagement.endDate")}
        </div>
        <div className="billMgnt__itemValue">
          {Number(serviceList[serviceNo]?.serviceEndTime) === 0
            ? t("siteManagement.paymentHistory.paymentManagement.unlimited")
            : `${subscriptionEndDate} 09:00`}
        </div>
      </div>
      {/* 결제 수단 */}
      {serviceList[serviceNo]?.billType !== "PROMOTION" &&
        serviceList[serviceNo]?.billType !== "TRIAL" && (
          <div className="billMgnt__item">
            <div className="billMgnt__itemKey">
              {t("siteManagement.paymentHistory.payment.title")}
            </div>
            <div className="billMgnt__itemValue">
              {serviceList[serviceNo]?.payCompany === "CASH"
                ? t("siteManagement.paymentHistory.payment.cash")
                : serviceList[serviceNo]?.priceType === "promotion"
                  ? t("siteManagement.paymentHistory.payment.coupon")
                  : t("siteManagement.paymentHistory.payment.card")}
            </div>
          </div>
        )}

      {/* 다음 결제 주기 다가올때 현금 결제 시 결제 요청 및 입금자명 입력 부분 */}
      {serviceList[serviceNo]?.payCompany === "CASH" &&
        //serviceList[serviceNo]?.billType === 'PAY' &&
        ((serviceList[serviceNo]?.payTerm === "month" &&
          dateDifference <= 10) ||
          (serviceList[serviceNo].payTerm === "year" &&
            dateDifference <= 20)) &&
        serviceUid !== "" &&
        userCashStatus?.status !== "APPLY" && (
          <div className="billMgnt__item">
            <div className="billMgnt__itemKey">{t("admin.cashMgnt.list")}</div>
            <div className="billMgnt__itemValue">
              <div>
                <div>
                  <p>{"· " + t("cashStatus.pay.bank") + ": 하나은행"}</p>
                  <p className="mg mt-4">
                    {"· " + t("cashStatus.pay.account") + ": 128-910004-64004"}
                  </p>
                  <p className="mg mt-4">
                    {"· " + t("cashStatus.pay.receiver") + ": 주식회사 파수"}
                  </p>
                  <p className="mg mt-4">
                    {"· " + t("cashStatus.pay.totalPrice") + " : "}
                    <NumberFormat
                      num={userCashStatus.totalPrice}
                      // displayType={"text"}
                      // thousandSeparator={true}
                      // prefix={"￦"}
                    />
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignContent: "center",
                    flexWrap: "wrap",
                  }}
                  className="mg mt-10"
                >
                  <input
                    type="checkbox"
                    name="taxInvoidFields"
                    id={"taxInvoidFields"}
                    // value={showTaxInvoiceFields}
                    // checked={showTaxInvoiceFields}
                    // onChange={toggleTaxInvoidFields}
                    // htmlFor={"taxInvoidFields"}
                  />
                  <label
                    className="inputArea-label"
                    htmlFor={"taxInvoidFields"}
                  ></label>
                  <span className={`form-input-label textEllipsis mg ml-8`}>
                    {t("cashStatus.taxInvoice.title")}
                  </span>
                </div>
                {showTaxInvoiceFields && (
                  <div>
                    <div className="flex align-center mg mt-10">
                      <span className={`billMgnt__tax title ${lang}`}>
                        {t("cashStatus.taxInvoice.owner")}
                      </span>
                      <div>
                        <input
                          id="owner"
                          name="owner"
                          value={userCashStatus.taxInvoiceDTO.owner}
                          // onChange={handleChangeTaxInvoice}
                          className="form-control custom-form width w-370 mg ml-8"
                          placeholder={t(
                            "cashStatus.taxInvoice.placeHolder.owner",
                          )}
                        />
                      </div>
                    </div>
                    <div className="flex align-center mg mt-10">
                      <span className={`billMgnt__tax title ${lang}`}>
                        {t("cashStatus.taxInvoice.businessNumber")}
                      </span>
                      <div>
                        <input
                          id="businessNumber"
                          name="businessNumber"
                          value={userCashStatus.taxInvoiceDTO.businessNumber}
                          // onChange={handleChangeTaxInvoice}
                          className="form-control custom-form width w-370 mg ml-8"
                          placeholder={t(
                            "cashStatus.taxInvoice.placeHolder.businessNumber",
                          )}
                        />
                      </div>
                    </div>
                    <div className="flex align-center mg mt-10">
                      <span className={`billMgnt__tax title ${lang}`}>
                        {t("cashStatus.taxInvoice.requestDate")}
                      </span>
                      <div style={{ marginLeft: 8, width: 222 }}>
                        <DatePicker
                          id="date_picker_1"
                          peekNextMonth
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          placeholderText=""
                          dateFormat="YYYY-MM-DD"
                          // onChange={(e) => handleChangeTaxRequestDate(e)}
                          onChange={(e) => {}}
                          disabled={false}
                          // minDate={null}
                          minDate={new Date()}
                          value={moment(
                            userCashStatus.taxInvoiceDTO.requestDate,
                          ).format("YYYY-MM-DD")}
                          name="requestDate"
                          selected={
                            userCashStatus.taxInvoiceDTO.requestDate
                              ? new Date(
                                  userCashStatus.taxInvoiceDTO.requestDate,
                                )
                              : null
                          }
                          className="form-control react-datepicker custom-date width w-100p"
                          autoComplete="off"
                          locale={lang}
                        />
                      </div>
                    </div>
                    <div className="flex align-center mg mt-10">
                      <span className={`billMgnt__tax title ${lang}`}>
                        {t("cashStatus.taxInvoice.issuer")}
                      </span>
                      <div>
                        <input
                          id="issuer"
                          name="issuer"
                          value={userCashStatus.taxInvoiceDTO.issuer}
                          // onChange={handleChangeTaxInvoice}
                          className="form-control custom-form width w-370 mg ml-8"
                          placeholder={t(
                            "cashStatus.taxInvoice.placeHolder.issuer",
                          )}
                        />
                      </div>
                    </div>
                    <div className="flex align-center mg mt-10">
                      <span className={`billMgnt__tax title ${lang}`}>
                        {t("cashStatus.taxInvoice.phoneNumber")}
                      </span>
                      <div>
                        <input
                          id="phoneNumber"
                          name="phoneNumber"
                          value={userCashStatus.taxInvoiceDTO.phoneNumber}
                          // onChange={handleChangeTaxInvoice}
                          className="form-control flexControl custom-form width w-370 mg ml-8"
                          placeholder={t(
                            "cashStatus.taxInvoice.placeHolder.phoneNumber",
                          )}
                        />
                      </div>
                    </div>
                    <div className="flex align-center mg mt-10">
                      <span className={`billMgnt__tax title ${lang}`}>
                        {t("cashStatus.taxInvoice.email")}
                      </span>
                      <div>
                        <input
                          id="email"
                          name="email"
                          value={userCashStatus.taxInvoiceDTO.email}
                          // onChange={handleChangeTaxInvoice}
                          className="form-control custom-form width w-370 mg ml-8"
                          placeholder={t(
                            "cashStatus.taxInvoice.placeHolder.email",
                          )}
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className="flex align-center mg mt-10">
                  <span className={`billMgnt__tax title ${lang}`}>
                    {t("cashStatus.pay.sender")}
                  </span>
                  <input
                    id="newDepositName"
                    name="newDepositName"
                    value={newDepositName}
                    type="text"
                    placeholder={t("admin.upc.site.enterDeposit")}
                    style={{ width: 222, marginLeft: 8 }}
                    className={
                      newDepositName === ""
                        ? "form-control custom-form"
                        : `${
                            newDepositName === ""
                              ? "form-control form-textbox-valid custom-form"
                              : "form-control form-textbox-invalid custom-form"
                          }`
                    }
                    // onChange={handleChange}
                  />

                  <button
                    type="button"
                    // onClick={() => requestCashStatus()}
                    className="btn btn-green mg mr-10 ml-8"
                    style={{ height: "41px" }}
                    disabled={
                      newDepositName === "" ||
                      (showTaxInvoiceFields &&
                        (userCashStatus.taxInvoiceDTO.owner === "" ||
                          userCashStatus.taxInvoiceDTO.businessNumber === "" ||
                          userCashStatus.taxInvoiceDTO.issuer === "" ||
                          userCashStatus.taxInvoiceDTO.phoneNumber === "" ||
                          userCashStatus.taxInvoiceDTO.email === ""))
                    }
                  >
                    {t("admin.cashMgnt.status.wait")}
                  </button>
                  {/* {cashStatus === "APPLY" && (
              <button
                type="button"
                onClick={() => requestCashStatus("CANCEL")}
                className="btn btn-green mg mr-10"
                style={{ height: "41px" }}
              >
                {t("admin.cashMgnt.removePayment")}
              </button>
            )} */}
                </div>
              </div>
            </div>
          </div>
        )}

      {/* 이미 현금 결제에 대한 요청이 이루어졌다면 */}
      {userCashStatus.status === "APPLY" && (
        <div className="billMgnt__item">
          <div className="billMgnt__itemKey">
            {t("admin.cashMgnt.requestPayment")}
          </div>
          <div className="billMgnt__itemValue">
            <div>
              <span>{t("cashStatus.waitNotice")}</span>
              <div className="flex justify-flex text text--13 mg mt-10">
                <button
                  type="button"
                  //onClick={() => requestCashStatus('APPLY')}
                  onClick={() => showCashReqModal()}
                  className="btn btn-green "
                  style={{ height: "41px" }}
                  //disabled={newDepositName === ''}
                >
                  {t("cashStatus.removePayment")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PayInfoSection;
